import React from 'react';
import { Modal } from 'antd';
import { useModal } from '../context/modal';
import { useBanner } from '../hooks/banners/library/use-banner';
import { useClientId } from '../hooks/use-client-id';
import { AssetModal } from './asset-modal/asset-modal';

export const GlobalBannerModal: React.FC = () => {
  const { selectedAssetId, closeModal } = useModal();

  const clientId = useClientId();
  const asset = useBanner(selectedAssetId);

  if (!selectedAssetId) return null;

  if (!asset) {
    return (
      <Modal open={true} onCancel={closeModal} footer={null}>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>Cargando asset...</div>
      </Modal>
    );
  }

  return <AssetModal clientId={clientId} banner={asset} open={true} onClose={closeModal} />;
};
